export default () => ({
  dashboard: null,
  dashboardBreakout: null,
  dashboardTop3: null,
  dashboardTop: null,
  dashboardProfit: null,
  dashboardCycleTimes: null,
  dashboardTrend: null,
  dashboardView: 'Tops',
  dashboardOpportunities: null,
  startDate: null,
  endDate: null,
  invoiceView: null,
  invoiceFirm: null,
  analyzeView: null,
  analyzeViews: [
    {
      value: 1,
      name: 'by service (counts)',
      type: 'Trends|Breakout'
    },
    {
      value: 2,
      name: 'by service (sales)',
      type: 'Trends|Breakout'
    },
    {
      value: 3,
      name: 'by vehicle make (counts)',
      type: 'Trends|Breakout'
    },
    {
      value: 4,
      name: 'by vehicle make (sales)',
      type: 'Trends|Breakout'
    },
    {
      value: 5,
      name: 'by tech (hours)',
      type: 'Trends|Breakout'
    },
    {
      value: 6,
      name: 'by tech (cost)',
      type: 'Trends|Breakout'
    },
    {
      value: 7,
      name: 'all',
      type: 'Tops|Profit'
    },
    {
      value: 8,
      name: 'single location',
      type: 'Invoicing|Technicians|Payments'
    },
    {
      value: 9,
      name: 'all locations',
      type: 'Invoicing|Technicians|Payments'
    }
  ],
  rangeView: null,
  rangeViews: [
    {
      value: 1,
      name: 'yesterday',
      type: 'Top|Profit|Sales|Net|Cycle Times|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 8,
      name: 'today',
      type: 'Top|Profit|Sales|Net|Cycle Times|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 2,
      name: 'this week',
      type: 'Top|Profit|Sales|Net|Cycle Times|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 3,
      name: 'this month',
      type: 'Top|Profit|Sales|Net|Cycle Times|Trends|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 4,
      name: 'this qtr',
      type: 'Top|Profit|Sales|Net|Cycle Times|Trends|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 5,
      name: 'past 6 months',
      type: 'Top|Profit|Sales|Net|Cycle Times|Trends|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 6,
      name: 'past year',
      type: 'Top|Profit|Sales|Net|Cycle Times|Trends|Breakout|Invoicing|Technicians|Payments'
    },
    {
      value: 7,
      name: 'date range',
      type: 'Top|Profit|Sales|Net|Cycle Times|Breakout|Invoicing|Technicians|Payments'
    }
  ],
  payroll: null,
  techData: null,
  payments: null,
  log: [],
  logParameters: null,
  calibrateHistory: null,
  tz: null,
  fragmentation: [],
  missingIndexes: []
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js